import { useTranslations } from "next-intl";
import { useClosetItemInShortReview } from "@hooks/use-review-short";
import Button from "@components/core/Button";
import ReviewClosetItem from "@components/views/Reviews/ReviewClosetItem";

function FitStep({ onSelect }) {
  const t = useTranslations("common");

  const closetItem = useClosetItemInShortReview();

  return (
    <>
      <div className="w-100 pb-5 px-3">
        <ReviewClosetItem closetItem={closetItem} />
      </div>
      <div className="d-flex flex-column justify-content-center">
        <h5 className="mb-0 text-center">{t("review_short.how_size")}</h5>

        <div className="d-flex gap-3 w-100 flex-column pt-4 mt-2">
          <Button
            variant="ghost-primary"
            onClick={() => onSelect("too_small")}
            className="bg-white"
          >
            {t("review_short.too_small")}
          </Button>
          <Button
            variant="ghost-primary"
            onClick={() => onSelect("perfect")}
            className="bg-white"
          >
            {t("review_short.perfect")}
          </Button>
          <Button
            variant="ghost-primary"
            onClick={() => onSelect("too_large")}
            className="bg-white"
          >
            {t("review_short.too_large")}
          </Button>
        </div>
      </div>
    </>
  );
}

export default FitStep;
